import Nullstack from 'nullstack';
export default function IconAbc({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-abc",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 16v-6a2 2 0 1 1 4 0v6"
  }), "   ", Nullstack.element("path", {
    d: "M3 13h4"
  }), "   ", Nullstack.element("path", {
    d: "M10 8v6a2 2 0 1 0 4 0v-1a2 2 0 1 0 -4 0v1"
  }), "   ", Nullstack.element("path", {
    d: "M20.732 12a2 2 0 0 0 -3.732 1v1a2 2 0 0 0 3.726 1.01"
  }), " ");
}